// @ts-strict-ignore
import { Component, OnInit } from "@angular/core";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: C.EWIZ_GID1_GID2_CONFIGURATION,
  templateUrl: "./gid1-gid2-configuration.component.html",
  standalone: false
})
export class EWizGID1GID2ConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck, ProgressCheck {
  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.errorCheck(this.profileValues, this.dataService);
  }

  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.groupIdentifiers && +values.groupIdentifiers.useGroupIdentifiers === 1) {
      if (!dataService.isNullOrEmpty(values.groupIdentifiers.gid1) && !dataService.validHexValue(values.groupIdentifiers.gid1, 1, 8)) {
        this.errorMessage = $localize`GID1 value must be between 1 and 8 HEX bytes in length`;
        this.errorFound = true;
      } else if (
        !dataService.isNullOrEmpty(values.groupIdentifiers.gid2) &&
        !dataService.validHexValue(values.groupIdentifiers.gid2, 1, 8)
      ) {
        this.errorMessage = $localize`GID2 value must be between 1 and 8 HEX bytes in length`;
        this.errorFound = true;
      }
    }

    return this.errorFound;
  }

  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    if (+values.groupIdentifiers.useGroupIdentifiers === 1) {
      if (dataService.isNullOrEmpty(values.groupIdentifiers.gid1) && dataService.isNullOrEmpty(values.groupIdentifiers.gid2)) {
        return false;
      }
    }

    return true;
  }

  updateGroupIdentifiers() {
    this.profileValues.usimServiceTable.usimService17 = false;
    this.profileValues.usimServiceTable.usimService18 = false;

    if (this.profileValues.groupIdentifiers && +this.profileValues.groupIdentifiers.useGroupIdentifiers === 1) {
      if (!this.dataService.isNullOrEmpty(this.profileValues.groupIdentifiers.gid1)) {
        this.profileValues.usimServiceTable.usimService17 = true;
      }

      if (!this.dataService.isNullOrEmpty(this.profileValues.groupIdentifiers.gid2)) {
        this.profileValues.usimServiceTable.usimService18 = true;
      }
    }

    this.handleFormEvents();
  }
}
